export interface Stop {
  id: string;
  name: string;
  stopNumber: number;
  location: { lat: string; long: string };
  offsetLocation?: { lat: string; long: string };
  travelTime: number;
  triggerStop?: string;
  students?: string[];
  routeId?: string;
  createdAt?: Date;
  updatedAt?: Date;
  autoTransition?: boolean;
}

export enum RouteType {
  PICK_UP_ROUTE = 'PICK_UP_ROUTE',
  DROP_OFF_ROUTE = 'DROP_OFF_ROUTE'
}

export interface Route {
  id: string;
  name: string;
  departureWindow: {
    from: string;
    to: string;
  };
  stops?: string[];
  busId?: string;
  school: string;
  isDeleted: boolean;
  type: RouteType;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface Bus {
  id: string;
  name: string;
  licensePlateNo: string;
  school: string;
  deviceId?: string;
  isDeleted: boolean;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface RouteWithDetailedView {
  id: string;
  name: string;
  departureWindow: {
    from: string;
    to: string;
  };
  travelTime: number;
  arrivalWindow: string;
  stops?: Stop[];
  busId?: string;
  bus?: Bus;
  school: string;
  type: RouteType;
  isDeleted: boolean;
  createdAt?: Date;
  updatedAt?: Date;
}

export type StopDetailedView = Stop & {
  route: Route;
  bus: Bus;
  triggerStopName: string;
};

export enum RouteManagementTab {
  ROUTES = 'routes',
  STOPS = 'stops'
}

export enum RouteSubTab {
  All = 'all_routes',
  PICK_UP_ROUTES = 'pickup_routes',
  DROP_OFF_ROUTES = 'dropoff_routes'
}
